import * as React from "react";
import { Modal,Button,Input} from "antd";
import { connect } from "react-redux";

interface IFinanceProps {
  id:any;
  submitTag:any;
  getOrderDetails:any;
}

// 确认函
class Finance extends React.Component<IFinanceProps, any> {
  state = {
    visible:false,
    content:'',
  };
  constructor(props: IFinanceProps) {
    super(props);
  }

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  }
  
  show(id) {
    this.setState({
      visible:true
    })
  }

  onChange =(value) => {
    this.setState({
      content:value.target.value
    })     
  }
  
  onOk= () =>{
    const param: any = {
      id: this.props.id,
      type: 'cai',
      ordertext:this.state.content
    }; 
    this.props.submitTag({
      ...param,
      callback: (data) => {
          this.handleCancel();
          const params: any = {
            id: this.props.id
          }; 
          this.props.getOrderDetails({
            ...params,
            callback: () => {
              console.log(this.props);
            }
           });
      }
     }); 
  }

  render() {
    const buttonStyle = {
      backgroundColor: "#fff",
      color:"#000",
      border:'none',
      display: 'block',
    };
    return (
      <React.Fragment>
      <Button style={buttonStyle}onClick={this.show.bind(this,this.props.id)}>财务</Button> 
      <Modal maskClosable={false}  onOk={this.onOk}  onCancel={this.handleCancel} title="财务"  visible={this.state.visible}  width="auto" centered={true}>
          <div className="abnormal">
              <Input placeholder="关联订单号" value={this.state.content} onChange={this.onChange} />
          </div>
      </Modal> 
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
});

const mapDispatch = dispatch => {
  return {
    submitTag:dispatch.orderDetails.submitTag,
    getOrderDetails: dispatch.orderDetails.getOrderDetails,
  };
};

export default connect(
  mapState ,
  mapDispatch
)(Finance);
